import { Component, OnInit } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { ApiService } from 'src/app/services/api.service';
import { debounceTime } from 'rxjs/operators';
import { Router } from '@angular/router';
import { Subscription } from 'rxjs';
import { TranslationService } from 'src/app/services/translation.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.css']
})
export class ProfileComponent implements OnInit {
  constructor(
    private apiService: ApiService,
    private router: Router,
    public translations: TranslationService
  ) { }

  emailTaken: boolean = false;
  formCtrlSub: Subscription;
  url = this.apiService.url + '/uploads/';
  invalid: boolean = false;
  questions: Array<any> = [];
  user = this.apiService.user;
  profileForm = new FormGroup({
    firstname: new FormControl(this.user.firstname, Validators.required),
    lastname: new FormControl(this.user.lastname, Validators.required),
    city: new FormControl(this.user.city, Validators.required),
    country: new FormControl(this.user.country, Validators.required),
    email: new FormControl(this.user.email, [Validators.required, Validators.email]),
    age: new FormControl(this.user.age, Validators.required),
    gender: new FormControl(this.user.gender ? this.user.gender : 'male', Validators.required),
    image: new FormControl(this.user.profilePic),
  });

  get email() { return this.profileForm.get('email'); }

  ngOnInit() {
    if(this.user.profiles) {
      this.questions = this.user.profiles.questions.map(data => {
        let savedQuestions = this.user.questions.filter((q) => q.question == data.question);
        if(savedQuestions.length != 0) {
          data.savedAnswer = savedQuestions[0].answers[0].text;
          return savedQuestions[0];
        } else {
          return { question: data.question, answers: [{ text: data.answers[0].text }] }
        }
      });
      console.log(this.questions, this.user.profiles.questions);
    }
    this.formCtrlSub = this.profileForm.controls['email'].valueChanges
      .pipe(debounceTime(1500))
      .subscribe(newValue => {
        if (this.profileForm.controls['email'].valid) {
          this.apiService.checkMail({ email: newValue }).subscribe((res: any) => {
            if (res.data.length > 0 && res.data[0]._id !== this.user._id) {
              this.emailTaken = true;
            }
          });
        }
      });
  }

  ngOnDestroy() {
    this.formCtrlSub.unsubscribe();
  }

  checkChanged(formgroup, gender) {
    this.profileForm.get(formgroup).setValue(gender);
  }

  triggerFile() {
    document.getElementById('imageselector').click();
  }

  imageSelected(event) {
    event.preventDefault();
    if (event.target.files.length > 0) {
      let temp = [];
      temp.push(this.user._id);
      let file = event.target.files[0];
      this.profileForm.get('image').setValue(file);
      var fr = new FileReader();
      fr.onload = this.onFileReaderLoad;
      fr.readAsDataURL(file);
    }
  }

  onFileReaderLoad(e) {
    document.getElementById('pimg').setAttribute('src', e.target.result);
  };

  checkStatus(tocheck, string) {
    if (this.profileForm.get(tocheck).value == string) {
      return true;
    }
    return false;
  }

  answerChange(e, i) {
    this.questions[i].answers = [];
    this.questions[i].answers.push({ text: e.target.value });
  }

  submit() {
    let temp = [];
    this.invalid = false;
    temp.push(this.user._id);
    if (!this.profileForm.valid || this.emailTaken) {
      Object.keys(this.profileForm.controls).forEach(key => {
        this.profileForm.controls[key].markAsDirty();
      });
      this.invalid = true;
      return;
    }
    let formData = new FormData();
    formData.append('firstname', this.profileForm.get('firstname').value);
    formData.append('id', JSON.stringify(temp));
    formData.append('lastname', this.profileForm.get('lastname').value);
    formData.append('city', this.profileForm.get('city').value);
    formData.append('country', this.profileForm.get('country').value);
    formData.append('age', this.profileForm.get('age').value);
    formData.append('gender', this.profileForm.get('gender').value);
    formData.append('questions', JSON.stringify(this.questions));
    formData.append('email', this.profileForm.get('email').value);
    formData.append('pic', this.profileForm.get('image').value);

    this.apiService.updateUser(formData).subscribe((res => {
      this.router.navigate(['/community-groups']);
    }));

  }

}
